const homepageFaqs = [
  {
    question: "What is agentic commerce?",
    answer: "Agentic commerce is commerce mediated by autonomous AI agents that discover, evaluate, recommend, and transact on behalf of users. Instead of humans browsing websites, agents like ChatGPT, Gemini, and Claude compress the buyer journey into a single agent-driven flow — negotiating, bundling, and completing purchases for their users.",
  },
  {
    question: "Why is agentic commerce a 2026 priority for enterprises?",
    answer: "AI agents are becoming the primary interface for discovery and transactions. 40% of EU consumers already use AI for product research, 58% bypass traditional search, and ChatGPT has 800M+ weekly active users. Enterprises that aren't agent-ready in 2026 will lose consideration share to competitors whose offerings agents can find, trust, and transact with.",
  },
  {
    question: "How does agentic commerce change the buyer journey?",
    answer: "The traditional funnel — search, compare, evaluate, checkout — collapses into a single agent interaction. The buyer states intent once; the agent handles discovery, ranking, bundling, negotiation, and transaction. Brand visibility shifts from human SERPs to machine-readable signals that agents can parse and act on.",
  },
  {
    question: "What does it take for an enterprise to become agent-ready?",
    answer: "Agent readiness requires five capabilities: discoverability (structured product and service data), trust (verifiable credentials and identity), rankability (machine-readable differentiation), policy clarity (returns, pricing, eligibility expressed as rules), and transactability (APIs that let agents complete purchases end-to-end).",
  },
  {
    question: "How is GrowAgentic different from a traditional digital agency?",
    answer: "Traditional agencies optimize for human users — UX, SEO, paid media. GrowAgentic optimizes for autonomous agents acting on behalf of humans. We help enterprises redesign discovery, trust, bundling, orchestration, and marketplace participation so AI agents prefer their offerings during the agent-mediated buying decision.",
  },
  {
    question: "What happens if my enterprise waits to act on agentic commerce?",
    answer: "Agents are already mediating purchase decisions today. Enterprises that wait risk becoming invisible to agent-driven demand, forfeit ~22% efficiency gains from mature gen-AI marketing, and erode pricing power as agents bundle competitor offerings into the journey. The cost of inaction compounds month over month.",
  },
];

const HomepageFAQ = () => {
  return (
    <section id="faq" className="py-16 lg:py-24 bg-gradient-section">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">FAQ</span>
          <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl text-foreground">
            Frequently Asked <span className="text-gradient">Questions</span>
          </h2>
          <p className="mt-3 mx-auto max-w-xl text-sm text-muted-foreground">
            Key questions about agentic commerce and what it means for your enterprise.
          </p>
        </div>

        <div className="mx-auto max-w-3xl space-y-4">
          {homepageFaqs.map((faq, i) => (
            <details
              key={i}
              className="group rounded-2xl border border-border bg-card shadow-sm animate-fade-up"
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <summary className="cursor-pointer px-6 py-4 text-sm font-semibold text-foreground list-none flex items-center justify-between gap-4">
                {faq.question}
                <span aria-hidden="true" className="shrink-0 text-muted-foreground transition-transform group-open:rotate-45 text-lg">+</span>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-muted-foreground leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomepageFAQ;

export const homepageFaqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: homepageFaqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
};
